/**
 * Tuning policies and per-request options for the HTTP client.
 *
 * All policies are deep-merged with their defaults at `configureHttp` time
 * (see `config.ts`). Per-request options override the resolved policy for
 * that request only.
 */
export const DEFAULT_RETRY = {
    maxAttempts: 3,
    baseMs: 250,
    factor: 2,
    maxMs: 4000,
    jitter: true,
};
export const DEFAULT_BREAKER = {
    failureThreshold: 5,
    cooldownMs: 30_000,
    routeKeySegments: 3,
};
export const DEFAULT_TIMEOUT_MS = 30_000;
//# sourceMappingURL=types.js.map